/*
 * @Des 组件 视频区域
 * @Description
 * @Author
 * @Date
 */

/* HTML */
<template>
    <div :class="{'_table-item-box view-page-box position-map-view padding-l-none': true, 'max-box': !showTreeBoxFlag}" style="padding: 10px;">
        <section style="height: 100%;">

            <!-- 主内容 start -->
            <div :class="{'page-box': true, 'no-bsg': this.$checkEmpty(cameras)}">

                <!-- 地图 容器 -->
                <div class="map-box">
                    <SubRaphaelMap ref="svgMap" :class="{'off': this.$checkEmpty(maps)}" :mapEleId="'svg_map_camera'" />
                    <div :class="{'none-map-item': true, 'off': !this.$checkEmpty(maps)}" >
                        <img alt="暂无地图" title="暂无地图" src="@/static_dazzle/images/map_none.png" >
                    </div>
                </div>

                <!-- 视频区域列表 start -->
                <div class="items-box">
					
					<!-- row-item-box start -->
					<div :class="{'row-item-box': true, 'on': item.editNameFlag, 'item-detail-showed': item.showDetailFlag}" v-for="(item, index) in cameras" :key="index" @mousemove="mouseMoveDiv(item)" @mouseout="MouseOutDiv(item)">
						<span class="el-icon-arrow-right item-detail-btn cursor-pointer" title="详情" @click="toggleItemDetail(item, index)"></span>
						<!-- row-item-content start -->
						<div class="row-item-content row-item-title">
							<span class="item-content-label">名称：</span>
							<div class="item-content-wrap" style="padding-left: 0;">{{item.diskChannelName + " (" + item.number + ")"}}</div>
						</div>
						<!-- row-item-content end -->
						
						<!-- item-detail-box start -->
						<div class="item-detail-box" >
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">摄像头厂家：</span>
								<div class="item-content-wrap">{{matchRowsByKey(filters.brands, 'id', item.brand) ? matchRowsByKey(filters.brands, 'id', item.brand).name : '----'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">视频名称：</span>
								<div class="item-content-wrap">{{item.diskChannelName ? item.diskChannelName : '----'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">视频编号：</span>
								<div class="item-content-wrap">{{item.number ? item.number : '----'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">码流类型：</span>
								<div class="item-content-wrap">{{matchRowsByKey(filters.subtypes, 'id', item.subtype) ? matchRowsByKey(filters.subtypes, 'id', item.subtype).name : '----'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">编码格式：</span>
								<div class="item-content-wrap">{{matchRowsByKey(filters.codecs, 'id', item.codec) ? matchRowsByKey(filters.codecs, 'id', item.codec).name : '----'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">读取类型：</span>
								<div class="item-content-wrap">{{matchRowsByKey(filters.readModes, 'id', item.readMode) ? matchRowsByKey(filters.readModes, 'id', item.readMode).name : '----'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">通道号：</span>
								<div class="item-content-wrap">{{item.diskChannelNo ? item.diskChannelNo : '----'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">IP：</span>
								<div class="item-content-wrap">{{item.diskIp ? item.diskIp : '----'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">账号：</span>
								<div class="item-content-wrap">{{item.diskAccount ? item.diskAccount : '----'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">是否启用：</span>
								<div class="item-content-wrap">{{item.isOpen == 1 ? '已启用' : '未启用'}}</div>
							</div>
							<!-- row-item-content end -->
							<!-- row-item-content start -->
							<div class="row-item-content">
								<span class="item-content-label">关联地图：</span>
								<div class="item-content-wrap">{{map_list_maps.get(item.mapId) && map_list_maps.get(item.mapId).mapName ? map_list_maps.get(item.mapId).mapName : '----'}}</div>
							</div>
							<!-- row-item-content end -->
						</div>
						<!-- item-detail-box end -->
						
						<!-- item btns box start -->
						<div class="item-btns-box" >
                        <span v-if="item.editFlag">绘制区域至少需要获取三个点</span>
                        <span v-if="item.editPointFlag">双击地图获取位置点</span>
	                    	<i v-if="item.editFlag || item.editPointFlag" class="el-icon-close" title="取消" @click="cancelEditRow(item, index)">取消</i>
	                    	<i v-if="item.editPointFlag" class="el-icon-check" title="保存" @click="sureEditPoint(item, index)">保存</i>
	                    	
<!--	                    	<i v-if="!item.editFlag && !item.editPointFlag" class="el-icon-edit" title="编辑摄像头配置" @click="editInfo(item, index)">编辑</i>-->
                        <i v-if="!item.editFlag && !item.editPointFlag" class="el-icon-location" title="设置摄像头位置" @click="editPoint(item, index)">标注</i>
	                    	<i v-if="!item.editFlag && !item.editPointFlag" class="iconfont el-icon-my_dianziweilan1" title="编辑摄像头区域" @click="editRow(item, index)">绘制区域</i>
	                    	<i v-if="item.editFlag" class="el-icon-check" title="保存" @click="sureEditRow(item, index)">保存</i>
	                    	<i v-if="(item.pointX != null || item.pointY != null || item.points != '') && !item.editFlag && !item.editPointFlag" class="el-icon-delete" title="清除视频" @click="deleteRow(item, index)">清除</i>
	                    </div>
	                    <!-- item btns box end -->

					</div>
					<!-- row-item-box end -->
					
                </div>
                <!-- 视频区域列表 end -->

                <!-- 区域列表 start -->
                <div class="area-items-box" v-show="areas.length >= 1">
                    <ul>
                        <li v-for="(item, index) in areas"
                            :key="index"
                            :class="{'on': item.id == filters.areaId}"
                            :title="item.name"
                            @click="changeArea(item)">{{item.name}}</li>
                        <li v-if="this.$checkEmpty(areas)" title="暂无区域">暂无区域</li>
                    </ul>
                </div>
                <!-- 区域列表 end -->

                <!-- 地图列表 start -->
                <div class="map-items-box" v-show="maps.length >= 1">
                    <ul>
                        <li v-for="(item, index) in maps"
                            :key="index"
                            :class="{'on': item.mapId == filters.mapId}"
                            :title="item.name"
                            @click="changeMap(item)">{{item.mapName}}</li>
                        <li v-if="this.$checkEmpty(maps)" title="暂无地图">暂无地图</li>
                    </ul>
                </div>
                <!-- 区域列表 end -->

                <!-- 操作按钮 start -->
                <div class="handle-btns-box">
                    <el-button type="primary" :class="{'on': showVideoFlag}" icon="iconfont el-icon-my_shiping-xue" size="mini" trigger="click" @click="toggleVideoFlag()" title="显示/隐藏 视频" ></el-button>
                </div>
                <!-- 操作按钮 start -->

            </div>
            <!-- 主内容 end -->

            <!-- 编辑视频 -->
            <VideoDialog ref="videoDialog"
                         :areas="areaMaps"
                         :subtypes="filters.subtypes"
                         :codecs="filters.codecs"
                         :brands="filters.brands"
                         :read-modes="filters.readModes"
                         @reSearch="searchCamera"
            />

        </section>
    </div>
</template>

/* JS */
<script>
	// 公共变量
	import GlobalVariable from '@/global/global-variable'
	// 公共方法
	import GlobalFun from '@/global/global-function'
	// svg地图 组件
	import SubRaphaelMap from '@/components/SubRaphaelMap'
	// dialog 组件
	import VideoDialog from './VideoDialog'
	import ApiVideo from "@/request/api-video";
	// API 组织结构
	import ApiOam from "@/request/api-oam";
	
	export default {
		/**
		 * @Des 名称
		 * @Auth
		 * @Date
		 */
	    name: "VideoRegion",
	    props: {
	        /**
	         * @Des 展示box
	         * @Auth
	         * @Date
	         */
	        showTreeBoxFlag: {
	            type: Boolean,
	            default: function (){
	                return true
	            }
	        },// showTreeBoxFlag
	    },// props
	    /**
	     * @Des 组件引用
	     * @Auth
	     * @Date
	     */
	    components: {
	        // svg地图 组件
	        SubRaphaelMap,
	        // dialog 组件
	        VideoDialog
	    },// components
	    /**
	     * @Des 数据定义
	     * @Auth
	     * @Date
	     */
	    data() {
	        return {
	            /**
	             * @Des filters
	             * @Auth
	             * @Date
	             */
	            filters: {
	                areaId: '',
	                mapId: '',
	                orderBy: {
	                    number: 'asc'
	                },
	                readModes: [{
	                    id: 1,
	                    name: '硬盘录像机'
	                },{
	                    id: 2,
	                    name: '摄像头'
	                }],
	                brands: [{
	                    id: 1,
	                    name: '海康'
	                },{
	                    id: 2,
	                    name: '宇视'
	                },{
	                    id: 3,
	                    name: '大华'
	                }],
	                subtypes: [{
	                    id: 1,
	                    name: '主码流'
	                },{
	                    id: 2,
	                    name: '子码流'
	                }],
	                codecs: [{
	                    id: 1,
	                    name: 'H.264'
	                },{
	                    id: 2,
	                    name: 'H.265'
	                }],
	            },
	            // svg elem
	            mapSub: this.$refs.svgMap,
	            // 展示摄像头
	            showVideoFlag: true,
	            newRow: {
	                // 新增flag
	                addRowFlag: false,
	                // 点集合
	                points: [],
	                // 摄像头id
	                cameraId: '',
	            },
	            
	            // 组织结构 list
				orgList: [],
				// 地图 总list
				orgMaps: [],
	            // 区域
	            areas: [],
	            areaMaps: [],
	            // 地图
	            maps: [],
	            // 缓存  记录 区域信息
				map_list_areas: new this.HashMap(),
				// 缓存  记录 地图信息
				map_list_maps: new this.HashMap(),
	            
	            // 摄像头
	            cameras: [],
	            // 记录视频
	            videoRow: {},
	            // 首尾点 最小距离
	            limitDis: 20,
	            railLine: {
	                color: 'blue',
	                width: 4
	            },
	            editRailFlag: false,
	            editPointFlag: false,
	        }// return
	    },// data()
	    /**
	     * @Des 加载完成
	     * @Auth
	     * @Date
	     */
	    mounted() {
	    	// svg elem
            this.mapSub = this.$refs.svgMap;

            // 设置 摄像头参数
            this.mapSub.setCameraOpt({clickCameraImg: this.clickCameraImg});

            // 查询结构
			this.searchOrg();
	    },// mounted
	    /**
	     * @Des 初始加载
	     * @Auth
	     * @Date
	     */
	    created() {
	        
	    },// created
	    /**
	     * @Des 销毁
	     * @Auth
	     * @Date
	     */
	    destroyed() {
	        // 销毁 svg地图
	        this.mapSub.destroySvg();
	    },// destroyed
	    /**
	     * @Des 注册 方法
	     * @Auth
	     * @Date
	     */
	    methods: {
			/**
			 * @Des 鼠标进入
			 * @Auth
			 * @Date
			 */
	        mouseMoveDiv(row){
	            if(!this.editRailFlag){
	                this.clearMapGroup(row);
	                this.railLine = {
	                    color: 'red',
	                    width: 4
	                }
	                this.refreshMapGroup(row);
	            }
	        },// mouseMoveDiv
			/**
			 * @Des 鼠标离开
			 * @Auth
			 * @Date
			 */
	        MouseOutDiv(row){
	            if(!this.editRailFlag){
	                this.clearMapGroup(row);
	                this.railLine = {
	                    color: 'blue',
	                    width: 4
	                }
	                this.refreshMapGroup(row);
	            }
	        },// MouseOutDiv
	        /**
			 * @Des 数据匹配
			 * @Auth
			 * @Date
			 */
	        matchRowsByKey(rows, key, val){
	            let obj = {};
	            let keys = Object.keys(rows);
	            keys.forEach((_key, index) => {
	            	let row = Object.assign({}, rows[_key]);
	            	if (row[key] == val) {
	            		obj = Object.assign({}, row);
	            	}
	            });
	            return obj;
	        },// matchRowsByKey
	        
	        /**
	         * @Des 查询 组织结构
	         * @Auth
	         * @Date 
	         */
	        searchOrg() {
	            this.$request.postJsonRequest(ApiOam.Find_Org_Uri,{
	                projectId: this.$store.state.currentProjectId
	            }).then(result => {
	                //console.log(result); return false;
	                
	                // 树形下拉 区域下显示地图 根据subsectionId关联区域
	                this.areaMaps = GlobalFun.dataToTree( Object.assign([], result.data), {
	                    id: 'id',
	                    pid: 'parentId',
	                    children: 'children',
	                    label: 'name',
	                });
	                
	                // 组织结构 list
	                this.orgList = Object.assign([], result.data);
	                
	                let orgAreas = [];// 区域
	                let orgMaps = [];// 地图
	                // 缓存
					this.map_list_areas.clear();
					// 缓存
					this.map_list_maps.clear();
	                // 缓存 区域
	                this.orgList.forEach((row, index) => {
	                	// 空值 跳过
	                	if (this.$checkEmpty(row)) return true;
	                	
	                	if (row.level == 2) {
	                		// 区域
	                		orgAreas.push(Object.assign({}, row.node, {label: row.node.areaName}));
	                		// 缓存
	                		this.map_list_areas.put(row.node.areaId, Object.assign({}, row.node, {label: row.node.areaName}));
	                	}
	                	if (row.level == 3) {
	                		// 地图
	                		orgMaps.push(Object.assign({}, row.node));
	                		// 缓存  记录 地图信息
	                		this.map_list_maps.put(row.node.mapId, Object.assign({}, row.node, {label: row.node.mapName}));
	                	}
	                });
	                
	                // 区域
	                this.areas = Object.assign([], orgAreas);
	                // 地图
	                this.orgMaps = Object.assign([], orgMaps);
	                
	                // 当前选中项
	                let currItem = this.getCurrItem(this.areas, this.filters.areaId, 'areaId');
	                // 切换区域
	                this.changeArea(currItem);
	            }).catch(error => {
	                console.error('查询组织结构异常', ApiOam.Find_Org_Uri, error);
	            })
	        },// searchOrg
	        /**
	         * @Des 切换区域
	         * @Auth
	         * @Date
	         */
	        changeArea(row) {
	            //console.log(row);
	            // filters
	            this.filters.areaId = Object.assign({areaId: '', mapId: ''}, row).id;
	
	            // 查询地图
	            this.searchMaps();
	        },// changeArea
	
	        /**
	         * @Des 查询地图
	         * @Auth
	         * @Date
	         */
	        searchMaps() {
	            // 地图集合
	            this.maps = [];
	            // 缓存 地图
	            this.orgMaps.forEach((row, index) => {
	            	// 空值 跳过
	            	if (this.$checkEmpty(row)) return true;
	            	
	            	// 没有区域 || 地图处于当前区域
	            	if (this.$checkEmpty(this.areas) || row.areaId == this.filters.areaId) {
	            		let itemRow = Object.assign({}, row);
	            		// 检索 当前区域
	            		let currArea = this.map_list_areas.get(this.filters.areaId);
	            		// 区域有地铁
	            		if (!this.$checkEmpty(currArea) && currArea.hasMap == 1) {
	            			itemRow.pStartPointX = currArea.startPointX;
	            			itemRow.pStartPointY = currArea.startPointY;
	            			itemRow.pStartPointZ = currArea.startPointZ;
	            			itemRow.pHasMap = true;
	            		}
	            		// 缓存 地图
	            		this.maps.push(Object.assign({}, itemRow));
	            	}
	            });
	            
	            // 当前选中项
	            let currItem = this.getCurrItem(this.maps, this.filters.mapId, 'mapId');
	            // 目标空值
	            if (this.$checkEmpty(currItem)) {
	            	// 检索 当前区域
	            	let currArea = this.map_list_areas.get(this.filters.areaId);
	            	if (!this.$checkEmpty(currArea) && !this.$checkEmpty(currArea.mapUrl)) {
	            		// 初始化 svg地图
						//this.mapSub.initMap(Object.assign({}, currArea, {mapUrl: (GlobalVariable.BASE_PATH + currArea.mapUrl)}));
						this.mapSub.initMap(Object.assign({}, currArea, {mapUrl: ('data:image/png;base64,' + currArea.mapUrl), mapLevel: 1, tunnelPoints: currArea.tunnelPoints}));
		            	// 查询实时定位
		            	this.searchFence();
		            	// 查询基站
		            	this.searchBaseStation();
		            	// 查询工具柜
		            	//this.searchToolkits();
		            	
	            	} else {
	            		// 切换地图
	            		this.changeMap(this.maps[0]);
	            	}
	            	return false;
	            }
	            // 切换地图
	            this.changeMap(currItem);
	        },// searchMaps
	        /**
	         * @Des 切换地图
	         * @Auth
	         * @Date
	         */
	        changeMap(row) {
	            this.clearMapGroups();
	            this.cameras = [];
	            // 取消 绘制
	            this.cancelDraw();
				
				// 取消 编辑
				this.cancelEditRow(Object.assign({}, this.videoRow), this.videoRow.index);
				
	            // 空值 中止
	            if (this.$checkEmpty(row)) {
	                console.log('maps empty');
	                // 销毁 svg地图
	                this.mapSub.destroySvg();
	                this.filters.mapId = '';
	                return false
	            };
	
	            //console.log(row);
	            // filters
	            this.filters.mapId = Object.assign({areaId: '', mapId: ''}, row).mapId;
	
	            // 初始化 svg地图
	            this.mapSub.initMap(Object.assign({}, row, {mapUrl: ('data:image/png;base64,' + row.mapUrl), mapLevel: 2, tunnelPoints: row.tunnelPoints}));
	
	            // 查询视频
	            this.searchCamera();
	        },// changeMap
	        /**
	         * @Des 当前选中项
	         * @Auth
	         * @Date
	         */
	        getCurrItem(rows, onkey, key) {
	            // 空值 中止
	            if (this.$checkEmpty(rows)) return false;
	
	            // onrow
	            let onRow = null;
	            // 遍历 检索
	            rows.forEach((row, index) => {
	                if (onkey == row[key]) {
	                    onRow = row;
	                }
	            });
	            return (onRow == null ? rows[0] : onRow);
	        },// getCurrItem
			
			/**
			 * @Des 详情
			 * @Auth
			 * @Date 
			 */
			toggleItemDetail(row, index) {
				// 详情状态
                this.$set(this.cameras[index], 'showDetailFlag', !row.showDetailFlag);
			},// toggleItemDetail
			
			/**
			 * @Des 查询摄像头
			 * @Auth
			 * @Date
			 */
	        searchCamera(){
	            // 点集合
	            this.newRow.points = [];
	            // 摄像头id
	            this.newRow.cameraId = '';
	            // 清除 图元
	            this.mapSub.clearAllCameras('destroy');
	            // 清除 区域
	            this.clearMapGroups()
	
	            this.$request.postJsonRequest(ApiVideo.exportVideoApi, {
	                areaId: this.filters.areaId,
	                mapId: this.filters.mapId,
	                orderBy: this.filters.orderBy,
	                projectId: this.$store.state.currentProjectId,
	            }).then(result => {
	                this.cameras = result.rows;
	                // console.log(this.cameras)
	                // 刷新地图图元 摄像头
	                this.showVideoFlag && this.refreshMapCameras();
	                // 刷新地图图元 摄像头区域
	                this.refreshMapGroups();
	            }).catch(error => {
	                console.error('导出摄像头异常', ApiVideo.exportVideoApi, error);
	            })
	        },// searchCamera
	
	        /**
	         * @Des 添加视频区域
	         * @Auth
	         * @Date
	         */
	        addRow() {
	
	            if (!this.$checkEmpty(this.videoRow)) {
	                // 取消 编辑
	                this.cancelEditRow(this.cameras[this.videoRow.index], this.videoRow.index);
	            }
	
	            // 添加状态
	            this.newRow.addRowFlag = true;
	            // 点集合
	            this.newRow.points = [];
	            // 摄像头id
	            this.newRow.cameraId = '',
	            // 绘制类型：1多边形，2矩形，3圆形
	            this.newRow.eDrawType = 1,
	
	            // 设置 点集合
	            this.mapSub.setPointGroupData([]);
	            // 绘制 区域
	            this.mapSub.drawArea(true, (pointXY, points, disToFirst, realPoints) => {
	                // 自动完成
	                if (points.length >= 4 && disToFirst <= this.limitDis) {
	                    // 完成 绘制
	                    this.endDraw();
	                }
	            }, {color: 'blue', width: 4, limitDis: this.limitDis});
	        },// addRow
	        /**
	         * @Des 取消绘制
	         * @Auth
	         * @Date
	         */
	        cancelDraw(option) {
	            // 添加状态
	            this.newRow.addRowFlag = false;
	            // 点集合
	            this.newRow.points = [];
	            // 摄像头id
	            this.newRow.cameraId = '';
	
	            // 设置 点集合
	            this.mapSub.setPointGroupData([]);
	            // 绘制 区域
	            this.mapSub.drawArea(false, (pointXY, points, disToFirst, realPoints) => {
	                //console.log({pointXY, points});
	            });
	        },// cancelDraw
	        /**
	         * @Des 完成绘制
	         * @Auth
	         * @Date
	         */
	        endDraw(option) {
	            // 获取 点集合
	            this.newRow.points = this.mapSub.getDrowPoints();
	            // 少于3个点
	            if (this.newRow.points.length < 3) {
	                this.$message({
	                    message: '坐标点不可少于3个',
	                    type: 'warning',
	                    showClose: true,
	                    dangerouslyUseHTMLString: true
	                });
	                return false;
	            }
	            // 首尾相接
	            if (this.newRow.points[0] != this.newRow.points[this.newRow.points.length -1]) {
	                this.newRow.points.push(this.newRow.points[0]);
	            }
	
	            // 绘制 区域
	            this.mapSub.drawArea(false, (pointXY, points, disToFirst, realPoints) => {
	                //console.log({pointXY, points});
	            });
	
	            this.$refs.videoRegionDialog.openDialog(false, '新增视频区域', this.newRow.points);
	        },// endDraw
	
	        editInfo(row, index){
	            if(this.editRailFlag){
	                this.$message({
	                    message: '正在编辑视频区域',
	                    type: 'warning',
	                    showClose: true,
	                    dangerouslyUseHTMLString: true
	                });
	                return false;
	            }
	            this.$refs.videoDialog.openDialog(true, '编辑摄像头', row, index);
	        },// editInfo
			
			/**
	         * @Des 编辑 摄像头位置
	         * @Auth
	         * @Date
	         */
	        editPoint(row, index) {
	            if(this.editRailFlag){
	                this.$message({
	                    message: '正在编辑视频区域',
	                    type: 'warning',
	                    showClose: true,
	                    dangerouslyUseHTMLString: true
	                });
	                return false;
	            }
	            if(this.editPointFlag){
	                this.$message({
	                    message: '正在设置摄像头位置',
	                    type: 'warning',
	                    showClose: true,
	                    dangerouslyUseHTMLString: true
	                });
	                return false;
	            }
	            this.editPointFlag = true;
	            // 取消 绘制
	            this.cancelDraw();
	
	            this.videoRow = Object.assign({}, row, {index: index});
	            // 编辑状态
	            this.$set(row, 'editPointFlag', true);
	
	            // 清除图元 摄像头
	            this.clearMapCamera(row);
	            // 绘制圆点
	            this.mapSub.initDrawDisc('', 5, [row.pointX, row.pointY].join(','));
	            // 双击取点
                this.mapSub.allowDrawDisc(true, (startX, startY, realX, realY) => {
                	// 坐标
                	this.$set(row, 'pointX', realX);
                	this.$set(row, 'pointY', realY);
                });
	
	        },// editPoint
	        /**
	         * @Des 编辑 视频区域
	         * @Auth
	         * @Date
	         */
	        editRow(row, index) {
	            if(this.editRailFlag){
	                this.$message({
	                    message: '正在编辑视频区域',
	                    type: 'warning',
	                    showClose: true,
	                    dangerouslyUseHTMLString: true
	                });
	                return false;
	            }
	            if(this.editPointFlag){
	                this.$message({
	                    message: '正在设置摄像头位置',
	                    type: 'warning',
	                    showClose: true,
	                    dangerouslyUseHTMLString: true
	                });
	                return false;
	            }
	            this.editRailFlag = true;
	            // 取消 绘制
	            this.cancelDraw();
	
	            this.videoRow = Object.assign({}, row, {index: index});
	            // 编辑状态
	            this.$set(row, 'editFlag', true);
	
	            let points = this.$checkEmpty(row.points) ? [] : row.points.split(';');
	            // 去除首尾相同坐标
	            if (!this.$checkEmpty(points) && points[0] == points[points.length -1]) {
	                points.splice(points.length -1, 1);
	            }
	
	            // 清除 视频区域
	            this.mapSub.clearRail(row.id, 'destroy');
	            // 设置 点集合
	            this.mapSub.setPointGroupData(points);
	            // 绘制 区域
	            this.mapSub.drawArea(true, (pointXY, points, disToFirst, realPoints) => {
	                // 自动完成
	                if (points.length >= 4 && disToFirst <= this.limitDis) {
	                    // 确认 编辑
	                    this.sureEditRow(row, index);
	                }
	            }, {color: 'blue', width: 4, limitDis: this.limitDis});
	
	        },// editRow
	        /**
	         * @Des 取消 编辑
	         * @Auth
	         * @Date
	         */
	        cancelEditRow(row, index) {
	            this.editRailFlag = false;
	            this.editPointFlag = false;
	            
	            // 数据还原
	            this.reductionRow(row, index);
	            // 编辑状态
	            this.$set(row, 'editFlag', false);
	            this.$set(row, 'editPointFlag', false);
	            
	            // 清除 区域
	            this.mapSub.clearDrawArea();
	            // 绘制图元
	            this.refreshMapGroup(Object.assign({}, this.cameras[index]));
				
				// 双击取点
                this.mapSub.allowDrawDisc(false, (startX, startY) => {});
                // 清除 实心圆
                this.mapSub.clearDiscImg('destroy');
                // 绘制图元
	            this.refreshMapCamera(Object.assign({}, this.cameras[index]));
				
	        },// cancelEditRow
	        /**
	         * @Des 确认 设置坐标
	         * @Auth
	         * @Date
	         */
	        sureEditPoint(row, index) {
	            this.editPointFlag = false;
	            // 编辑状态
	            this.$set(row, 'editPointFlag', false);
	
	            // 交互锁 编辑
	            if(this.locked_updatePoint) return false;
	            this.locked_updatePoint = true;
	            
	            // 双击取点
                this.mapSub.allowDrawDisc(false, (startX, startY) => {});
	
	            // 交互 参数
	            let formData = Object.assign({}, row, {projectId: this.$store.state.currentProjectId});
	
	            // 交互
	            this.$request.postJsonRequest(ApiVideo.updateVideoPointApi, formData).then(result => {
	                if (result.code == 0) {
	                    this.$message({
	                        message: '坐标点设置成功！',
	                        type: 'success',
	                        showClose: true,
	                        dangerouslyUseHTMLString: true
	                    });
	                    this.$set(this.cameras, index, row);
	                } else {
	                    this.$message({
	                        message: result.msg,
	                        type: 'error',
	                        showClose: true,
	                        dangerouslyUseHTMLString: true
	                    });
	                    // 数据还原
	                    this.reductionRow(row, index);
	                }
	
	                // 清除 实心圆
	                this.mapSub.clearDiscImg('destroy');
	                // 绘制图元
	                this.refreshMapCamera(this.cameras[index]);
	
	                // 交互锁 编辑
	                this.locked_updatePoint = false;
	            }).catch(error => {
	            	this.locked_updatePoint = false;
	                // 清除 实心圆
	                this.mapSub.clearDiscImg('destroy');
	                // 绘制图元
	                this.refreshMapCamera(this.cameras[index]);
	                // 交互锁 编辑
	                console.error('编辑摄像头异常', ApiVideo.updateVideoPointApi, error);
	            })
	        },// sureEditPoint
	        /**
	         * @Des 确认 编辑
	         * @Auth
	         * @Date
	         */
	        sureEditRow(row, index) {
	            this.editRailFlag = false;
	            // 编辑状态
	            this.$set(row, 'editFlag', false);
	
	            // 交互锁 编辑
	            if(this.locked_update) return false;
	            this.locked_update = true;
	
	            // 获取 点集合
	            let points = this.mapSub.getDrowPoints();
	            // 少于3个点
	            if (points.length < 3) {
	                this.$message({
	                    message: '坐标点不可少于3个',
	                    type: 'warning',
	                    showClose: true,
	                    dangerouslyUseHTMLString: true
	                });
	                return false;
	            }
	            // 首尾相接
	            if (points[0] != points[points.length -1]) {
	                points.push(points[0]);
	            }
	
	            // 绘制 区域
	            this.mapSub.drawArea(false, (pointXY, points, disToFirst, realPoints) => {
	                //console.log({pointXY, points});
	            });
	            // 更新 区域坐标
	            row.points = points.join(';');
	
	            // 交互 参数
	            let formData = Object.assign({}, row, {projectId: this.$store.state.currentProjectId, groupId: row.id});

	            // 交互
	            this.$request.postJsonRequest(ApiVideo.updateVideoPointApi, formData).then(result => {
	                if (result.code == 0) {
	                    this.$message({
	                        message: '区域编辑成功！',
	                        type: 'success',
	                        showClose: true,
	                        dangerouslyUseHTMLString: true
	                    });
	                    this.$set(this.cameras, index, row);
	                } else {
	                    this.$message({
	                        message: result.msg,
	                        type: 'error',
	                        showClose: true,
	                        dangerouslyUseHTMLString: true
	                    });
	                    // 数据还原
	                    this.reductionRow(row, index);
	                }
	
	                // 清除 区域
	                this.mapSub.clearDrawArea();
	                // 绘制图元
	                this.refreshMapGroup(this.cameras[index]);
	
	                // 交互锁 编辑
	                this.locked_update = false;
	            }).catch(error => {
	                // 清除 区域
	                this.mapSub.clearDrawArea();
	                // 交互锁 编辑
	                this.locked_update = false;
	                console.error('编辑摄像头异常', ApiVideo.updateVideoPointApi, error);
	            })
	        },// sureEditRow
	        // 数据还原
	        reductionRow(row, index) {
	            let videoRow = Object.assign({}, this.videoRow);
	            // 数据还原
	            this.$set(this.cameras, index, videoRow);
	            // 清除记录
	            this.videoRow = {};
	        },// reductionRow
	
	        /**
	         * @Des 删除数据
	         * @Auth
	         * @Date
	         */
	        deleteRow(row, index){
	            this.$confirm(
					'确认清除地图上的视频：'+ (row.diskChannelName + '(' + row.number + ')') +'吗？','询问',
					{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						closeOnClickModal : false,
						type: 'warning'
					}
				).then(_ => {
					// 删除数据 交互
					this.requestDelete(row, index);
	            }).catch(_ => {
	            	//console.log('cancel')
	            });
	        },// deleteRow
	        /**
	         * @Des 删除数据 交互
	         * @Auth
	         * @Date
	         */
	        requestDelete(row, index){
	            this.$request.postJsonRequest(ApiVideo.deleteRegionApi, {
	                cameraId: row.cameraId,
	                projectId: this.$store.state.currentProjectId,
	            }).then(result => {
	                if (result.code == 0) {
	                    this.$message({
	                        message: '视频已在地图上清除！',
	                        type: 'success',
	                        showClose: true,
	                        dangerouslyUseHTMLString: true
	                    });
	                    // 清除 区域
	                    this.cancelEditRow(row, index);
	                    // 修改成功，重新查询
	                    this.searchCamera();
	                } else {
	                    this.$message({
	                        message: result.msg,
	                        type: 'error',
	                        showClose: true,
	                        dangerouslyUseHTMLString: true
	                    });
	                }
	            }).catch(error => {
	                console.error('区域清除异常', ApiVideo.deleteRegionApi, error);
	            })
	        },// requestDelete
	
	        /**
	         * @Des 切换摄像头展示状态
	         * @Auth
	         * @Date
	         */
	        toggleVideoFlag() {
	            // 展示 摄像头
	            this.showVideoFlag = !this.showVideoFlag;
	
	            // 清除 图元
	            this.mapSub.clearAllCameras('destroy');
	
	            // 刷新地图图元 摄像头
	            this.showVideoFlag && this.refreshMapCameras();
	        },// toggleVideoFlag
			/**
	         * @Des 清除图元 摄像头
	         * @Auth
	         * @Date
	         */
	        // 清除图元 摄像头
	        clearMapCamera(row) {
	            // 清除 图元
	            // 空值 跳过
	            if (this.$checkEmpty(row)) return true;
	
	            // 清除 区域
	            this.mapSub.clearCamera(row.id, 'destroy');
	        },// clearMapCamera
	        /**
	         * @Des 绘制图元 视频区域
	         * @Auth
	         * @Date
	         */
	        refreshMapCamera(row) {
	            // 展示 摄像头
	            if (!this.showVideoFlag) return false;
	            
	            // 空值 跳过
	            if (this.$checkEmpty(row)) return true;
	            // 清除 视频区域
	            this.mapSub.clearCamera(row.id, 'destroy');
				
                if (!this.$checkEmpty(row.pointX) && !this.$checkEmpty(row.pointY)) {
                	// 绘制 摄像头
                	this.mapSub.loadCameraPosition(row);
                }
	        },// refreshMapCamera
	        /**
	         * @Des 刷新地图图元 摄像头
	         * @Auth
	         * @Date
	         */
	        refreshMapCameras() {
	            // 展示 摄像头
	            if (!this.showVideoFlag) return false;
	
	            // 重新绘制
	            this.cameras.forEach((row, index) => {
	                // 空值 跳过
	                if (this.$checkEmpty(row)) return true;
	                row.index = index;
	                row.id = row.cameraId;
	                if (!this.$checkEmpty(row.pointX) && !this.$checkEmpty(row.pointY)) {
	                	// 绘制 摄像头
	                	this.mapSub.loadCameraPosition(row);
	                }
	            });
	        },// refreshMapCameras
	        clickCameraImg(data){
	            this.$refs.videoDialog.openDialog(true, '编辑摄像头', data, data.index);
	        },// clickCameraImg
	        /**
	         * @Des 清除图元 视频区域组
	         * @Auth
	         * @Date
	         */
	        clearMapGroup(row) {
	            // 清除 图元
	            // 空值 跳过
	            if (this.$checkEmpty(row)) return true;
	
	            // 清除 区域
	            this.mapSub.clearRail(row.id, 'destroy');
	        },// clearMapGroup
	        /**
	         * @Des 清除图元 视频区域组
	         * @Auth
	         * @Date
	         */
	        clearMapGroups() {
	            // 清除 图元
	            this.cameras.forEach((row, index) => {
	                // 空值 跳过
	                if (this.$checkEmpty(row)) return true;
	
	                // 清除 区域
	                this.mapSub.clearRail(row.id, 'destroy');
	            });
	        },// clearMapGroups
	        /**
	         * @Des 绘制图元 视频区域
	         * @Auth
	         * @Date
	         */
	        refreshMapGroup(row) {
	            // 空值 跳过
	            if (this.$checkEmpty(row)) return true;
	            // 清除 视频区域
	            this.mapSub.clearRail(row.id, 'destroy');
	
	            // points
	            let points = [];
	            if (!this.$checkEmpty(row.points)) {
	            	points = this.$checkEmpty(row.points) ? [] : row.points.split(';');
	            	points.push(points[0]);
	            }
	            // lineObj
	            // railObj
	            let railObj = {id: row.id, row: row, points: points, lineObj: this.railLine};
	
	            // 绘制 视频区域
	            this.mapSub.loadRail(railObj);
	        },// refreshMapGroup
	        /**
	         * @Des 绘制图元 视频区域组
	         * @Auth
	         * @Date
	         */
	        refreshMapGroups() {
	            // 重新绘制
	            this.cameras.forEach((row, index) => {
	                // 空值 跳过
	                if (this.$checkEmpty(row)) return true;
	
	                // points
		            let points = [];
		            if (!this.$checkEmpty(row.points)) {
		            	points = this.$checkEmpty(row.points) ? [] : row.points.split(';');
		            	points.push(points[0]);
		            }
	                // lineObj
	                // railObj
	                let railObj = {id: row.id, row: row, points: points, lineObj: this.railLine};
	
	                // 绘制 视频区域
	                this.mapSub.loadRail(railObj);
	            });
	        },// refreshMapGroups
	
	    },// methods
	    /**
	     * @Des 监听
	     * @Auth
	     * @Date
	     */
	    watch: {
	
	    },// watch
	
	}
</script>

/* CSS */
<style lang="scss" scoped>
	.items-box {
		.row-item-box {
			.item-btns-box {
				i {
					font-size: 14px;
				}/* i */
			}/* item-btns-box */
		}/* row-item-box */
	}/* items-box */
</style>



// WEBPACK FOOTER //
// src/components_pages/Video/VideoRegion.vue